export const getDeployments = async (url) => {
  const updatedUrl = url.replace("deployments", "deployments.json");
  const response = await fetch(updatedUrl);
  if (!response.ok) throw new Error("Failed to fetch deployments");
  const data = await response.json();
  return {
    rows: data.deployments,
    rowCount: data.total,
  };
};

export const createDeployment = async () => {
  const response = await fetch("/deployments.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":
        document.querySelector('[name="csrf-token"]')?.content || "",
    },
    body: JSON.stringify({
      deployment: {
        deployment_status: null,
        app_in_date: null,
        e_sign_date: null,
        application_status: null,
        approved_date: null,
        deployment_date: null,
        merchant_id: null,
        mid_type: null,
        sales_channel_id: null,
        processor_id: null,
        platform_id: null,
        projected_volume: 0,
        bp_price: 0,
        per_transaction: 0,
        cc_ach_form: null,
        hardware_payment_term: null,
        deployment_type: null,
        pci_required: false,
        fixed_rate: false,
      },
    }),
  });

  if (!response.ok) throw new Error("Failed to create deployment");
  return response.json();
};

export const updateDeployment = async (deploymentId, columnId, newValue) => {
  const response = await fetch(`/deployments/${deploymentId}.json`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":
        document.querySelector('[name="csrf-token"]')?.content || "",
    },
    body: JSON.stringify({
      deployment: {
        [columnId]: newValue,
      },
    }),
  });

  if (!response.ok) throw new Error("Failed to update deployment");
  return response.json();
};

export const deleteDeployment = async (deploymentId) => {
  const response = await fetch(`/deployments/${deploymentId}.json`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":
        document.querySelector('[name="csrf-token"]')?.content || "",
    },
  });

  if (!response.ok) throw new Error("Failed to delete deployment");
};
